import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {signoutUser} from '../../Auth/actions';
import {toggleDrawer} from "../../Layout/actions";
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import menuItems from "../menuItems";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_drawer';

class DashboardDrawer extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    onSignoutClick = e => {
        e.preventDefault();

        this.props.signoutUser();
    };

    onMenuItemClick = () => {
        this.props.toggleDrawer('dashboard', false);
    };

    toggleDrawer = (drawer, open) => (e) => {
        e.preventDefault();

        this.props.toggleDrawer(drawer, open);
    };

    render() {
        const {user} = this.props.auth;

        const menu = (
            <Fragment>
                <List component="nav">
                    <ListItem component={props => <NavLink to="/" exact {...props} />} onClick={this.onMenuItemClick} button>
                        <ListItemText primary={this.props.translate('dashboard_drawer.button_back_home')} />
                    </ListItem>
                    {menuItems.map((item, index) => {
                        return (
                            <ListItem key={index} component={props => <NavLink to={item.path} exact {...props} onClick={this.onMenuItemClick} />} button>
                                <ListItemText primary={this.props.translate(item.label)} />
                            </ListItem>
                        )
                    })}
                </List>
            </Fragment>
        );

        return (
            <Drawer anchor="right" open={this.props.layout.dashboardDrawerOpen} onClose={this.toggleDrawer('dashboard', false)} id="dashboard-drawer" className="header-drawer" classes={{
                paper: 'header-drawer-paper full',
            }}>
                <div className="wrapper wrapper-top">
                    <div className="inner">
                        <div className="drawer-title">
                            <span className="section">{this.props.translate('dashboard_drawer.welcome_user', {name: user.full_name})}</span>
                            <h2 className="title"><Translate id="dashboard_drawer.mon_espace" /></h2>
                            <Button size="large" className="btn-close-drawer" onClick={this.toggleDrawer('dashboard', false)}>
                                <CloseIcon className="m-icon"  />
                            </Button>
                            <Button size="small" variant="outlined" id="btn-signout" onClick={this.onSignoutClick}>
                                <Translate id="dashboard_drawer.button_signout" />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-bottom">
                    <div className="inner">
                        {menu}
                    </div>
                </div>
            </Drawer>
        );
    }
}

DashboardDrawer.propTypes = {
    toggleDrawer: PropTypes.func.isRequired,
    signoutUser: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    layout: state.layout,
});

export default connect(mapStateToProps, {signoutUser, toggleDrawer})(withLocalize(DashboardDrawer));



// WEBPACK FOOTER //
// ./src/features/Dashboard/components/DashboardDrawer.js